@if (reviewMode) {
  <div style="display: inline-block; width: 64%; margin-top: 1rem">
    <div class="form-status-container">
      <div class="form-status-column">
        @if (!!projectId) {
          <span class="project-id-title">Form #{{ projectId }}</span>
        }
      </div>
      <div
        class="form-status-column-right"
        [class.activityClosed]="!formActivityVisible"
        style="display: inline-block; float: right"
      >
        @if (reviewMode) {
          <button [matMenuTriggerFor]="menu" class="action-button" matTooltip="Actions">
            <mat-icon style="color: rgb(0, 120, 158)">more_vert</mat-icon>
          </button>
        }
        <mat-menu #menu="matMenu">
          @if (reviewMode) {
            <button mat-menu-item (click)="openDeleteConfirmationDialog()">
              <span>Delete Form</span>
            </button>
          }
        </mat-menu>
        @if (!hideActivityCTA) {
          <div class="exitButton" (click)="toggleFormActivity()">
            <span class="exitText">ACTIVITY</span>
          </div>
        }
      </div>
    </div>
  </div>
}

<app-real-estate-form-activity
  [formActivityVisible]="formActivityVisible"
  [reviewMode]="reviewMode"
  [formActivity]="formActivity"
  [showDerivationError]="showDerivationError"
  [projectData]="projectData"
  [formStatus]="formStatus"
  [userEmail]="userEmail"
  [formOwner]="formOwner"
  [currentAssignment]="currentAssignment"
  [isReadyForDOAApproval]="isReadyForDOAApproval"
  [isReadyForITSpareApproval]="isReadyForITSpareApproval"
  [readyToAddAccountingCodeBlock]="readyToAddAccountingCodeBlock"
  [emailRecipients]="emailRecipients"
  [(reviewComments)]="reviewComments"
  (toggleActivity)="toggleFormActivity()"
  (approve)="approveForm($event)"
></app-real-estate-form-activity>

@if (reviewMode) {
  <div class="formAdminSection">
    <div class="formAdminTitle">
      <span>Form Admin</span>
    </div>
    <div style="margin-bottom: 0.2rem">
      <div style="display: inline-block; margin-right: 7.25rem; white-space: nowrap">
        <span class="headerText">Form Owner</span>
      </div>
      <div style="display: inline-block; white-space: nowrap">
        <span class="headerText">Current Assignment</span>
      </div>
    </div>
    <div>
      <div style="display: inline-block; width: 12.145rem">
        @if (formOwner && formOwner.givenName && formOwner.surname) {
          <span class="subHeaderText" style="cursor: pointer"
            >{{ formOwner.givenName }} {{ formOwner.surname }}</span
          >
        }
        @if (formOwner && !(formOwner.givenName && formOwner.surname)) {
          <span class="subHeaderText" style="cursor: pointer">{{ formOwner.displayName }}</span>
        }
      </div>
      <div style="display: inline-block; width: 12.313rem">
        @if (currentAssignment && currentAssignment.givenName && currentAssignment.surname) {
          <span (click)="launchAssignmentDialog()" class="subHeaderText" style="cursor: pointer"
            >{{ currentAssignment.givenName }} {{ currentAssignment.surname }}</span
          >
        }
        @if (currentAssignment && !(currentAssignment.givenName && currentAssignment.surname)) {
          <span (click)="launchAssignmentDialog()" class="subHeaderText" style="cursor: pointer">{{
            currentAssignment.displayName
          }}</span>
        }
        @if (isCurrentApprover() && !readyToAddAccountingCodeBlock) {
          <img
            (click)="launchAssignmentDialog()"
            style="width: 1rem; margin-left: 0.2rem; cursor: pointer"
            src="assets/review-edit.svg"
          />
        }
      </div>
    </div>
  </div>
}

<form [formGroup]="realEstateProjectForm" class="realEstateProjectForm">
  <div class="projectHeader">
    <span id="pageTitle">Real Estate Funding Request</span>
    @if (reviewMode && !readyToAddAccountingCodeBlock) {
      <span
        (click)="exitReviewMode()"
        style="
          text-decoration: underline;
          cursor: pointer;
          font-size: 1.2rem;
          margin-left: 2rem;
          text-underline-offset: 3px;
        "
      >
        <img height="15px" src="assets/edit-pencil.svg" />
        Edit
      </span>
    }
  </div>
  <div>
    <app-real-estate-project-title
      [realEstateTitleForm]="realEstateTitleForm"
      [reviewMode]="reviewMode"
      [projectData]="projectData"
      [formStatus]="formStatus"
    ></app-real-estate-project-title>
  </div>
  @if (realEstateTitleForm.get('realEstateDepartment')?.value === 'REAL_ESTATE') {
    <div>
      <div class="projectSubHeader">
        <span>Part A: Project Detail Information</span>
      </div>
      <div>
        <app-real-estate-project-detail-info
          [realEstateDetailForm]="realEstateDetailForm"
          [reviewMode]="reviewMode || disableDetailSection"
          [fm]="realEstateTitleForm.get('fm').value"
          [pId]="pId"
          [formStatus]="formStatus"
        ></app-real-estate-project-detail-info>
      </div>
      <div class="projectSubHeader">
        <span>Part B: Project Justification</span>
      </div>
      <div>
        <app-real-estate-project-justification
          [reviewMode]="reviewMode"
          [realEstateJustificationForm]="realEstateJustificationForm"
        ></app-real-estate-project-justification>
      </div>
      <div class="projectSubHeader">
        <span>Part C: Capital Unit of Property (UOP) Details</span>
      </div>
      <div>
        <app-real-estate-project-uop
          [reviewMode]="reviewMode"
          [realEstateUopForm]="realEstateUopForm"
        ></app-real-estate-project-uop>
      </div>
      <div class="projectSubHeader">
        <span>Part D: Project Estimate Details & Accouting Codeblock</span>
      </div>
      <div>
        <app-real-estate-project-estimate
          [reviewMode]="reviewMode || disableEstimateSection"
          [realEstateEstimateForm]="realEstateEstimateForm"
          [projectId]="realEstateDetailForm.get('projectId').value"
          [state]="realEstateDetailForm.get('state').value"
          [omOperatingUnits]="realEstateDetailForm.get('omOperatingUnits').value"
          [capitalOperatingUnits]="realEstateDetailForm.get('capitalOperatingUnits').value"
          [omAccountNum]="realEstateDetailForm.get('omAccountNum').value"
          [capitalCwipAccountNum]="realEstateDetailForm.get('capitalCwipAccountNum').value"
          [capitalRwipAccountNum]="realEstateDetailForm.get('capitalRwipAccountNum').value"
          [serviceDate]="realEstateDetailForm.get('serviceDate').value"
          [startDate]="realEstateDetailForm.get('startDate').value"
        ></app-real-estate-project-estimate>
      </div>
      <div class="projectSubHeader">
        <span>Part E: Project Funding Approval</span>
      </div>
      <div>
        <app-real-estate-project-approver
          [reviewMode]="reviewMode"
          [approverList]="approverList"
          [doaAmounts]="doaAmounts"
        ></app-real-estate-project-approver>
      </div>
    </div>
  }

  @if (realEstateTitleForm.get('realEstateDepartment')?.value === 'LAND_SERVICES') {
    <div>
      <div class="projectSubHeader">
        <span>Part A: Project Detail Information</span>
      </div>
      <div>
        <app-land-services-project-detail-info
          [landServicesDetailForm]="landServicesDetailForm"
          [reviewMode]="reviewMode"
          [formStatus]="formStatus"
          [disposal]="realEstateTitleForm.get('disposal').value"
          [acquisition]="realEstateTitleForm.get('acquisition').value"
        ></app-land-services-project-detail-info>
      </div>
      <div class="projectSubHeader">
        <span>Part B: Project Estimate Details</span>
      </div>
      <div>
        <app-land-services-project-estimate-details
          [landServicesEstimateDetailsForm]="landServicesEstimateDetailsForm"
          [reviewMode]="reviewMode"
          [acquisition]="realEstateTitleForm.get('acquisition').value"
          [disposal]="realEstateTitleForm.get('disposal').value"
          [projectType]="landServicesDetailForm.get('projectType').value"
          [region]="realEstateTitleForm.get('region').value"
        ></app-land-services-project-estimate-details>
      </div>
      <div class="projectSubHeader">
        <span>Part C: Accounting Codeblock</span>
      </div>
      <div>
        <app-land-services-accounting-codeblock
          [landServicesAccountingForm]="landServicesAccountingForm"
          [reviewMode]="reviewMode"
        ></app-land-services-accounting-codeblock>
      </div>
      <div class="projectSubHeader">
        <span>Part D: Project Funding Approval</span>
      </div>
      <div>
        <app-real-estate-project-approver
          [reviewMode]="reviewMode"
          [approverList]="approverList"
          [doaAmounts]="doaAmounts"
        ></app-real-estate-project-approver>
      </div>
    </div>
  }

  @if (realEstateTitleForm.get('realEstateDepartment')?.value) {
    <div class="attachmentsSection">
      <app-attachments-section
        [editFormMode]="!reviewMode"
        [files]="files"
        [filesCopy]="filesCopy"
        (fileSelected)="onFileSelected($event)"
        (fileDropped)="onDrop($event)"
        (fileDragOver)="onDragOver($event)"
        (downloadFile)="downloadFile($event)"
        (deleteFile)="deleteFile($event)"
      ></app-attachments-section>
    </div>
  }
  @if (realEstateTitleForm.get('realEstateDepartment')?.value) {
    <div class="formActions">
      @if (!reviewMode) {
        <button class="button-primary" type="button" (click)="saveDraft()">
          <span class="confirmText">SAVE AS DRAFT</span>
        </button>
      }
      @if (!reviewMode) {
        <button class="button-primary" type="button" (click)="reviewForm()">
          <span class="confirmText">REVIEW</span>
        </button>
      }
    </div>
  }
</form>
